export var horizontalGutterSpace = 4;
export var backgroundColor = "backgroundLight";
export var borderRadiusSize = "mlarge";
export var shadowSize = "small";